import React from 'react';
import { Box, Text, Center, VStack } from '@chakra-ui/react';
import { appt } from '../../copy';

export const Appointment = () => {
	const handleClick = () => {
		window.open('mailto:jenna@vinemedical.com?subject=Consultation Request');
	};

	return (
		<Center className='appt-about-center'>
			<VStack className='appt-about-box2'>
				<Box textAlign='center'>
					<Center>
						<Text className='appt-about-headline'>{appt.headline}</Text>
					</Center>
				</Box>
				<Box textAlign='center'>
					<Center>
						<Text className='appt-about-copy'>{appt.copy}</Text>
					</Center>
				</Box>
				<Box
					as='button'
					onClick={handleClick}
					color='#e2796f'
					bg='rgba(0, 0, 0, 0)'
					borderColor='#e2796f'
					borderWidth='1px'
					transition='all 0.2s cubic-bezier(.08,.52,.52,1)'
					_hover={{
						bg: '#e2796f',
						color: 'white',
						borderColor: '#e2796f',
						borderWidth: '1px'
					}}
					className='appt-about-button'
				>
					{appt.button}
				</Box>
			</VStack>
		</Center>
	);
};
